import { render, staticRenderFns } from "./AdminTaskTypes.vue?vue&type=template&id=7136677a&scoped=true"
import script from "./AdminTaskTypes.vue?vue&type=script&lang=ts"
export * from "./AdminTaskTypes.vue?vue&type=script&lang=ts"
import style0 from "./AdminTaskTypes.vue?vue&type=style&index=0&id=7136677a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136677a",
  null
  
)

export default component.exports